import { GlobalEvents, useEventBusListener } from '../../../..';
/**
 * Listen for open issuer location events and execute the callback when one is received.
 * Put this in its own hook so that we can easily change the event name and event bus implementation in the future.
 * @param {(authorizationOrganization: AuthorizationOrganization) => void} eventReceivedCallback Callback to process when we receive an open issuer location event.
 */
export function useUserAuthorizationOrganizationSelectedEventListener(eventReceivedCallback) {
    useEventBusListener(GlobalEvents.SELECTED_USER_AUTHORIZATION_ORGANIZATION, eventReceivedCallback, {
        once: false,
    });
}
